import React from 'react';
import * as rxjs from 'rxjs';

import { makeStyles, FormControl, FormGroup, InputLabel, TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';

import * as Elevated from '@pitaman71/omniglot-introspect';
import { Annotations, Clients, Streams } from '@pitaman71/omniglot-live-data';

import { Modules } from '@pitaman71/omniglot-live-domains';

const __moduleName__ = `onniglot-live-react/MaterialUi`;

const useStyles = makeStyles((theme) => ({
    formControl: {
      wrap: 'nowrap'
    },
}));

export function PersonName(props: Partial<Annotations.Annotation<JSX.Element>> & {
    stream: Streams.ScalarStream<Modules.Identity.PersonName.TypeParams["Value"], Elevated.Domain<Modules.Identity.PersonName.TypeParams["Value"]>>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const domain = props.stream.domain;
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ value, setValue ] = React.useState<Modules.Identity.PersonName.TypeParams["Value"]|undefined>(undefined);
    const [ status, setStatus ] = React.useState<Streams.Status>({ initializing: true })
    const classes = useStyles();

    const client = Clients.ScalarClient.fromDelta<Modules.Identity.PersonName.TypeParams["Value"], Elevated.Domain<Modules.Identity.PersonName.TypeParams["Value"]>>(`${__moduleName__}/AsIdentity/PersonName(${props.stream.persistKey})`, setValue, setStatus);
    const [ subscription, setSubscription ] = React.useState<Streams.Subscriptions|undefined>();

    React.useEffect(() => {
        setSubscription(client.watchParent(props.stream));
        return (() => {
            if(subscription) {
                subscription.unsubscribe();
            }    
        })
    }, [ ])

    return (
        <React.Fragment>
            <FormGroup style={{ display: "block" }}>
                <FormControl>
                    <InputLabel shrink>{props.label}</InputLabel>
                    { /* first name */ }
                    <TextField type="text" placeholder='firstName'
                        value={value?.givenName === undefined ? '' : value.givenName} 
                        onChange={(event:any) => { 
                            const stateful = props.stream.stateful();
                            if(stateful === undefined) {
                                // skip
                            } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                                const parsed = { ... value, givenName: undefined };
                                stateful.assign(parsed);
                            } else if(domain) {
                                const parsed = { ... value, givenName: event.target.value.toString() };
                                stateful.assign(parsed);
                            }
                        }}
                    />
                    { /* last name */ }
                    <TextField type="text" placeholder='lastName'
                        value={value?.familyName === undefined ? '' : value.familyName} 
                        onChange={(event:any) => { 
                            const stateful = props.stream.stateful();
                            if(stateful === undefined) {
                                // skip
                            } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                                const parsed = { ... value, familyName: undefined };
                                stateful.assign(parsed);
                            } else if(domain) {
                                const parsed = { ... value, familyName: event.target.value.toString() };
                                stateful.assign(parsed);
                            }
                        }}
                    />
                </FormControl>
            </FormGroup>
        </React.Fragment>
    );
}

